export default "__VITE_ASSET__Cmz073Ro__"